import { ref } from 'vue';

export default (successFun) => {
    const show = ref(false);
    const row = ref({});

    function open(r) {
        show.value = true;
        row.value = r || {};
    }

    function close() {
        show.value = false;
        row.value = {};
    }

    function handleCancelSuccess({ articleId }) {
        successFun(articleId);
    }

    return { show, open, close, row, handleCancelSuccess }
}